<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <permission-btn moduleName='Tx_OrderPlans' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item txOrderplans">
      <div class="bg-white fh" id='txOrderPlans-table'>
        <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                  @selection-change="handleSelectionChange" @sort-change="handleSortChange">
          <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width"
                           :label="item.description"
                           :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false"
                           :show-overflow-tooltip="item.tooltip">
            <template slot-scope="scope">
              <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]"
                           v-if="item.isSel">
              </select-type>
              <span v-else-if="item.key === 'orderPlanCode'">
                  <a class="link-type"
                     @click.stop="openDrawer(scope.row,'txOrderPlans')">{{ scope.row.orderPlanCode }}</a>
                </span>
              <span v-else-if="item.key === 'invOrderCode'">
                  <a class="link-type" @click.stop="openDrawer(scope.row,'invOrders')">{{ scope.row.invOrderCode }}</a>
                </span>
              <span v-else>
                <span
                  v-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{
                    scope.row[item.key] | dateFormat
                  }}</span>
                <span v-else>{{ scope.row[item.key] }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
                    :limit.sync="listQuery.limit" @pagination="handleCurrentChange"/>
      </div>

      <!--使用createdFormId设置Dialog的id,通过id设置内部的样式，防止样式污染-->
      <add-instance ref="dataForm" :sourceCode="crmType"
                    createdFormId="txOrderPlans-dialog"
                    :visible.sync="dialogFormVisible"
                    :initData="initData">
      </add-instance>

      <edit-instance ref="editForm" :sourceCode="crmType"
                     createdFormId="txOrderPlans-dialog"
                     :visible.sync="dialogEditVisible"
                     :initData="temp">
      </edit-instance>

      <filter-form ref="queryForm" @filter="handleFilter" :code="crmType"
                   :dialog-visible.sync="dialogQueryVisible"/>

      <my-transfer :code="crmType" @filter="handleFilter"
                   :titles="['待配置列', '显示列']"
                   :dialog-visible.sync="dialogSetVisible"/>

      <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="drawerobjtype"
                   :menukeyArray="menukeyArray"></drawerViews>
    </div>
  </div>
</template>

<script>
import * as txOrderPlans from '@/api/tx_orderplans';
import mytable from '@/utils/crmtableFlowV2';
import * as invOrders from '@/api/invorders';

export default {
  name: 'txOrderPlans',
  components: {},
  mixins: [mytable],
  data() {
    return {
      crmType: 'Tx_OrderPlan',
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        AccountId: '' // 账套ID
      },
      initData: {
        AccountId: ''
      },
      rules: {}
    };
  },
  created() {
    this.initData.AccountId = this.getAccountId(); // 从V2文件中取到账套ID
    this.listQuery.AccountId = this.getAccountId();
  },
  methods: {
    getApi() {
      return txOrderPlans;
    },
    beforUpdate() {
      this.temp.typeMark = this.temp.typeMark.toString();
    },
    btnClickOther(bomid) {
      switch (bomid) {
        case 'btnCommit':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请提交一条记录',
              type: 'error'
            });
            return;
          } else {
            this.Commit();
          }
          break;
        case 'btnBack':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一条记录',
              type: 'error'
            });
            return;
          } else {
            this.Back();
          }
          break;
      }
    },
    Back() {
      this.$confirm('是否要退回', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.multipleSelection[0].id;
        txOrderPlans.Back(this.multipleSelection[0].id).then(res => {
          this.$message({
            message: '退回成功',
            type: 'success'
          });
          this.getList();
        }).catch((_) => {
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    Commit() {
      const state = this.multipleSelection[0].state;
      this.listLoading = true;
      if (state === 0) {
        this.$message({
          message: '该计划尚未处理，无法提交!',
          type: 'error'
        });
        this.getList();
      } else if (state === 2) {
        this.$message({
          message: '该计划已提交，无需重复提交!',
          type: 'error'
        });
        this.getList();
      } else if (state === 4) {
        this.$message({
          message: '请先提交合同审核!',
          type: 'error'
        });
        this.getList();
      } else if (state === 3) {
        this.$message({
          message: '该计划已生成采购订单，无需再次提交!',
          type: 'error'
        });
        this.getList();
      } else if (state === 5) {
        this.$message({
          message: '该计划审核中，无需重复提交!',
          type: 'error'
        });
        this.getList();
      } else if (state === 6) {
        this.$message({
          message: '该计划审核通过，无需重复提交!',
          type: 'error'
        });
        this.getList();
      } else if (state === 7) {
        this.$message({
          message: '该计划审核不通过，无需重复提交!',
          type: 'error'
        });
        this.getList();
      } else {
        txOrderPlans.Commit(this.multipleSelection[0].id).then(res => {
          this.$message({
            message: '提交成功',
            type: 'success'
          });
          this.listLoading = false;
          this.getList();
        }).catch((_) => {
          this.listLoading = false;
        });
      }
    },
    openDrawer(row, type) { // 打开抽屉
      this.drawerobjtype = type;
      if (type === 'txOrderPlans') {
        this.getApi().get(row.id).then(res => {
          this.drawertemp = { ...this.drawertemp, ...res.result };
          this.menukeyArray = [
            { name: '', menukey: 'tx_orderplansview' }
          ]; // 要显示的标签
          this.drawer = true;
        });
      } else if (type === 'invOrders') {
        invOrders.get(row.invOrderCode).then(res => {
          console.log(res);
          this.drawertemp = { ...this.drawertemp, ...res.result };
          this.menukeyArray = [
            { name: '', menukey: 'invordersview' }
          ]; // 要显示的标签
          this.drawer = true;
        });
      }
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}

/* 防止样式污染，使用id为每个页面定义表格体高度 */
#txOrderPlans-table .el-table__body-wrapper {
  height: calc(100% - 57px) !important;
}

.txOrderplans .edit_dialog {
  height: calc(100vh - 106px) !important;
  box-sizing: border-box;
}

.txOrderplans .el-dialog {
  margin: 0 !important;
  box-sizing: border-box;
  width: 100% !important;

}
</style>
